import type { PropType } from 'virtual-vue';
import { ArrowLeftIcon, SearchIcon } from '@tencent/wphk-icon-vue';
import { i18n } from '../i18n';
import type { SearchClearTrigger, SearchTheme } from './search';

export const DEFAULT_THEME: SearchTheme = 'grey';

/**
 * Search 组件的 props 定义
 */
export const props = {
  /**
   * Vue3 v-model 绑定值；与 value 互斥，优先读取
   */
  modelValue: {
    type: String,
    default: '',
  },

  /**
   * Vue2 v-model 绑定值；modelValue 未定义时读取
   */
  value: {
    type: String,
    default: '',
  },

  /**
   * 占位文本
   * @default i18n('search-placeholder')
   */
  placeholder: {
    type: String,
    default: () => i18n('search-placeholder'),
  },

  /**
   * 视觉风格
   * @default 'grey'
   */
  theme: {
    type: String as PropType<SearchTheme>,
    default: DEFAULT_THEME,
  },

  /**
   * 输入框光标颜色
   * @default '#07C160'
   */
  cursorColor: {
    type: String,
    default: '#07C160',
  },

  /**
   * 是否展示左侧返回控件
   * @default false
   */
  showBackControl: {
    type: Boolean,
    default: false,
  },

  /**
   * 返回控件图标组件
   */
  backIcon: {
    type: Object,
    default: () => ArrowLeftIcon,
  },

  /**
   * 返回控件无障碍文案
   * @default i18n('search-back')
   */
  backText: {
    type: String,
    default: () => i18n('search-back'),
  },

  /**
   * 取消按钮文案
   * @default i18n('search-cancel')
   */
  cancelText: {
    type: String,
    default: () => i18n('search-cancel'),
  },

  /**
   * 最大输入长度
   */
  maxlength: {
    type: Number,
    default: undefined,
  },

  /**
   * 左侧图标组件
   */
  leftIcon: {
    type: Object,
    default: () => SearchIcon,
  },

  /**
   * 是否显示清除按钮
   * @default true
   */
  clearable: {
    type: Boolean,
    default: true,
  },

  /**
   * 清除按钮无障碍文案
   * @default i18n('search-clear')
   */
  clearText: {
    type: String,
    default: () => i18n('search-clear'),
  },

  /**
   * 清除按钮触发时机
   * @default 'focus'
   */
  clearTrigger: {
    type: String as PropType<SearchClearTrigger>,
    default: 'focus',
  },
};
